/**
 * @generated SignedSource<<e28c7c62aa01a705c1330eebe68dd969>>
 * @relayHash 3316415bb3181ce961ae439dd588b1c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4e7591fbfb0ff75c07c66e1fcdb0a4eb12d871dbd12be831c0bca380a6ca4650

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type SpotlightTourContainerMutation$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type SpotlightTourContainerMutation$data = {
  readonly jira: {
    readonly userPreferences: {
      readonly setNaturalLanguageSpotlightTourEnabled: {
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SpotlightTourContainerMutation = {
  response: SpotlightTourContainerMutation$data;
  variables: SpotlightTourContainerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraUserPreferencesMutation",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isEnabled",
                "variableName": "isEnabled"
              }
            ],
            "concreteType": "JiraNaturalLanguageSearchSpotlightTourEnabledMutationPayload",
            "kind": "LinkedField",
            "name": "setNaturalLanguageSpotlightTourEnabled",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "success"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpotlightTourContainerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpotlightTourContainerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "4e7591fbfb0ff75c07c66e1fcdb0a4eb12d871dbd12be831c0bca380a6ca4650",
    "metadata": {},
    "name": "SpotlightTourContainerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1450a72b849b0b74ae2be10403976ab2";

export default node;
